// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var FileSizeBytes = function (x) {
    return x;
};
var tsBridgeFileSizeBytes = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedNumberType("FileSizeBytes")("__brandFileSizeBytes"));
    }
};
var writeFileSizeBytes = Simple_JSON.writeForeignNumber;
var unwrap = function (v) {
    return v;
};
var showFileSizeBytes = Data_Show.showNumber;
var readFileSizeBytes = Simple_JSON.readNumber;
var ordFileSizeBytes = Data_Ord.ordNumber;
var newtypeFileSizeBytes = {
    Coercible0: function () {
        return undefined;
    }
};
var makeFileSizeBytes = FileSizeBytes;
var eqFileSizeBytes = Data_Eq.eqNumber;
export {
    FileSizeBytes,
    makeFileSizeBytes,
    unwrap,
    newtypeFileSizeBytes,
    eqFileSizeBytes,
    ordFileSizeBytes,
    showFileSizeBytes,
    readFileSizeBytes,
    writeFileSizeBytes,
    tsBridgeFileSizeBytes
};
//# sourceMappingURL=index.js.map
